const jianjie = '海星股份成立于1998年，是中国铝电极箔行业领军企业。 总部位于江苏省南通市，在上海、香港、四川、宁夏、新疆、日本等地建有多家子公司，' +
    '于2019年国内主板上市（股票代码：603115）。公司是储能材料行业的重要参与者和推动者，主导产品——铝电极箔市场占有率全球排名第一，' +
    '产品广泛配套新能源汽车、储能系统、AI服务器、5G通信、工业控制、高端消费电子等快速增长的核心产业领域。'

const course = [
    {
        "Id":1,
        "Year":"1984年01月",
        "Content":"电极箔制造生产线"
    },
    {
        "Id":2,
        "Year":"1998年01月",
        "Content":"成立南通海星电子"
    },
    {
        "Id":3,
        "Year":"1998年12月",
        "Content":"成立南通中联科技"
    },
    {
        "Id":4,
        "Year":"2000年06月",
        "Content":"组建江苏中联科技"
    },
    {
        "Id":5,
        "Year":"2001年03月",
        "Content":"设立香港联力公司"
    },
    {
        "Id":6,
        "Year":"2003年03月",
        "Content":"成立南通海一电子"
    },
    {
        "Id":7,
        "Year":"2006年08月",
        "Content":"成立宁夏海力电子"
    },
    {
        "Id":8,
        "Year":"2007年08月",
        "Content":"成立四川中雅科技"
    },
    {
        "Id":9,
        "Year":"2013年08月",
        "Content":"完成股份制改革"
    },
    {
        "Id":10,
        "Year":"2017年03月",
        "Content":"成立日本昭和研究院"
    },
    {
        "Id":11,
        "Year":"2019年08月",
        "Content":"完成上交所主板A股上市（股票代码：603115）"
    },
    {
        "Id":12,
        "Year":"2021年",
        "Content":"完成非公开发行"
    },
    {
        "Id":13,
        "Year":"2022年",
        "Content":"成立上海海星联力"
    }
]

const honor = [
    { "Id":1, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/2018%E6%B1%9F%E8%8B%8F%E7%9C%81%E9%9A%90%E5%BD%A2%E5%86%A0%E5%86%9B%E4%BC%81%E4%B8%9A.jpg", "Remark": "2018江苏省隐形冠军企业" },
    { "Id":2, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/2019%E5%B8%82%E9%95%BF%E8%B4%A8%E9%87%8F%E5%A5%96.jpg", "Remark": "2019市长质量奖" },
    { "Id":3, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E5%9B%9B%E5%B7%9D%E7%9C%81%E4%BC%98%E7%A7%80%E6%B0%91%E8%90%A5%E4%BC%81%E4%B8%9A.jpg", "Remark": "四川省优秀民营企业" },
    { "Id":4, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E5%9B%9B%E5%B7%9D%E7%9C%81%E5%85%88%E8%BF%9B%E5%85%9A%E7%BB%84%E7%BB%87.jpg", "Remark": "四川省先进党组织" },
    { "Id":5, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E5%9B%BD%E5%AE%B6%E4%BC%81%E4%B8%9A%E6%8A%80%E6%9C%AF%E4%B8%AD%E5%BF%83.jpg", "Remark": "国家企业技术中心" },
    { "Id":6, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E5%9B%BD%E5%AE%B6%E9%AB%98%E6%96%B0%E6%8A%80%E6%9C%AF%E4%BC%81%E4%B8%9A.jpg", "Remark": "国家高新技术企业" },
    { "Id":7, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E5%B7%A5%E4%BA%BA%E5%85%88%E9%94%8B%E5%8F%B7.jpg", "Remark": "工人先锋号" },
    { "Id":8, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/honor/%E6%B1%9F%E8%8B%8F%E7%9C%81%E7%A7%91%E6%8A%80%E6%88%90%E6%9E%9C%E8%BD%AC%E5%8C%96%E4%B8%93%E9%A1%B9%E8%B5%84%E9%87%91%E9%A1%B9%E7%9B%AE%E6%89%BF%E6%8B%85%E5%8D%95%E4%BD%8D.jpg", "Remark": "江苏省科技成果转化专项资金项目承担单位" }
    ]

export function getJianjie() {
    return jianjie
}

export function getCourse() {
    return course
}

export function getHonor() {
    return honor
}



// WEBPACK FOOTER //
// ./src/mock/goto.js